export enum PatternTypeEnum {
    PermissionsLegend = "PermissionsLegend",
    AboutUs = "AboutUs",
    PrivacyPolicy = "PrivacyPolicy",
    TermsAndConditions = "TermsAndConditions",
}